import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { esimInfoENUM } from '../../../constants';
import handleBatchCreateEsims from '../../../services/apollo/func/handle/handleBatchCreateEsims';

export const getSchema = () => {
  const schema = yup.object().shape({
    eID: yup.string().trim().nullable(),
    firstEID: yup.string().trim().nullable(),
    lastEID: yup.string().trim().nullable(),
    status: yup.object().shape({}).required(''),
    licenseName: yup.object().shape()
      .when('status', {
        is: value => !value?.value,
        then: yup.object().shape({}).required(''),
        otherwise: yup.object().shape({}).nullable(),
      }),
  });
  return schema;
};

export const getForm = schema => useForm({
  mode: 'onChange',
  defaultValues: {
    eID: '',
    firstEID: '',
    lastEID: '',
    licenseName: undefined,
    status: { label: esimInfoENUM.UNBLOCKED, value: false },
  },
  resolver: yupResolver(schema),
});

export const generateEIDs = (firstEID, lastEID) => {
  const result = [];
  for (let i = BigInt(firstEID); i <= BigInt(lastEID); i += 1n) {
    result.push(i.toString());
  }
  return result.map((value) => {
    const tmp = `${value}00`;
    const checkDigit = 98n - (BigInt(tmp) % 97n);
    if (+checkDigit.toString() < 10) {
      return `${value}0${checkDigit}`;
    }
    return `${value}${checkDigit}`;
  });
};

export const isValidEID = (eID) => {
  if (!eID) {
    return false;
  }
  const value = eID.slice(0, 30);
  const checkDigit = eID.slice(30);
  const checkCode = 98n - (BigInt(`${value}00`) % 97n);
  if (+checkCode.toString() === +checkDigit) return true;
  return false;
};

export const createBatchEsims = async (payload) => {
  try {
    const input = {
      esimIds: payload.esimIds,
      isBlocked: payload?.status?.value,
      licenseId: payload?.licenseName?.value,
    };
    const batchEsims = await handleBatchCreateEsims({ input });
    return batchEsims;
  } catch (error) {
    return {
      isSuccess: false,
      message: error.message,
    };
  }
};
